export const SESSION_TIMEOUT = 'SESSION_TIMEOUT';
export const SHOW_SESSION_TIMEOUT_DIALOG = 'SHOW_SESSION_TIMEOUT_DIALOG';
export const HIDE_SESSION_TIMEOUT_DIALOG = 'HIDE_SESSION_TIMEOUT_DIALOG';
export const UPDATE_SESSION = 'UPDATE_SESSION';
export const SET_SESSION_USER_ID = 'SET_SESSION_USER_ID';
export const RESTART_SESSION = 'RESTART_SESSION';
export const SESSION_LOGGED_OUT = 'SESSION_LOGGED_OUT';
export const SESSION_TIMED_OUT = 'SESSION_TIMED_OUT';
export const EB_KEEP_SESSION_LIVE = 'EB_KEEP_SESSION_LIVE';

export const timeout = ({ payload, error }) => ({
  payload,
  error,
  type: SESSION_TIMEOUT,
});

export const showSessionTimeoutDialog = payload => {
  return {
    payload,
    type: SHOW_SESSION_TIMEOUT_DIALOG,
  };
};

export const hideSessionTimeoutDialog = () => {
  return {
    type: HIDE_SESSION_TIMEOUT_DIALOG,
  };
};

export const updateSession = session => ({
  type: UPDATE_SESSION,
  broadcast: true,
  payload: session,
});

export const restartSession = () => ({
  type: RESTART_SESSION,
  broadcast: true,
});

export const setLoggedOut = () => ({
  type: SESSION_LOGGED_OUT,
  broadcast: true,
});

export const setSessionUserId = userId => ({
  type: SET_SESSION_USER_ID,
  broadcast: true,
  payload: userId,
});
